import { EpModal } from '../../components/EpModal';
import { useTranslation as t } from '../../hooks/useTranslation';
import styles from './EpModalHelpSupport.module.scss';
import { EpIcon } from '../EpIcon';

interface IEpModalHelpSupport {
  modalId: string;
  translations: unknown;
}

export const EpModalHelpSupport = ({
  translations,
  modalId,
}: IEpModalHelpSupport) => {
  const supportList = [
    {
      title: t(translations, 'Brazil Support'),
      mail: t(translations, 'brazilSupportEmail'),
      phone: t(translations, 'brazilSupportTelephone'),
    },
    {
      title: t(translations, 'Belgium Support'),
      mail: t(translations, 'belgiumSupportEmail'),
    },
    {
      title: t(translations, 'Chile Support'),
      mail: t(translations, 'chileSupportEmail'),
    },
    {
      title: t(translations, 'Colombia Support'),
      mail: t(translations, 'colombiaSupportEmail'),
    },
    {
      title: t(translations, 'France Support'),
      mail: t(translations, 'franceSupportEmail'),
    },
    {
      title: t(translations, 'Portugal Support'),
      mail: t(translations, 'portugalSupportEmail'),
    },
    {
      title: t(translations, 'Uruguay Support'),
      mail: t(translations, 'uruguaySupportEmail'),
    },
  ];

  return (
    <EpModal
      modalId={modalId}
      modalTitle={t(translations, 'Support')}
      modalType="default"
      modalButtonList={[
        {
          buttonSize: 'md',
          buttonId: 'modal__button--close',
          buttonText: t(translations, 'Close'),
          buttonType: 'secondary-outline',
          isCloseButton: true,
        },
      ]}
    >
      <div style={{ height: 'max-content' }}>
        {supportList.map((support, index) => (
          <div key={index}>
            <h3 className={styles['content__title']}>{support.title}</h3>

            <div className={styles['content__support-list']}>
              <EpIcon
                iconName="SolidEnvelop"
                iconSize={24}
                customClasses={styles['content__icon']}
              />
              <a
                className={styles['content__text']}
                href={`mailto:${support.mail}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {support.mail}
              </a>
            </div>

            {support.phone && (
              <div className={styles['content__support-list']}>
                <EpIcon
                  iconName="SolidMobile"
                  iconSize={24}
                  customClasses={styles['content__icon']}
                />
                <a
                  className={styles['content__text']}
                  href={`tel: ${support.phone}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {support.phone}
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </EpModal>
  );
};
